import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, reactive, computed } from 'vue';
import mangaApi from '@/api/manga';
import imageApi from '@/api/image'
import { config, userConfig } from '@/store'
import { tagItemType } from '@/type/tag';
import { characterItem, metaItemType } from '@/type/meta';
import { mangaInfoType } from '@/type/manga';
import { chapterInfoType } from '@/type/chapter';
import chapterApi from '@/api/chapter';
import { global_set, global_set_json } from '@/utils'
import lastReadApi from '@/api/last-read';
import collectApi from '@/api/collect';
import mangaTagBox from '@/components/manga-tag-box.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();

let mangaInfo = reactive<mangaInfoType>({
    mangaId: 0,
    mangaName: '',
    author: '',
    browseType: '',
    publishDate: '',
    createTime: '',
    updateTime: '',
    describe: '',
    chapterCount: 0,
});

let firstChapterInfo = ref<chapterInfoType>({
    browseType: '',
    chapterCover: '',
    chapterId: 0,
    chapterName: '',
    chapterPath: '',
    chapterType: '',
    createTime: '',
    mangaId: 0,
    mediaId: 0,
    pathId: 0,
    picNum: 0,
    updateTime: '',
});

let latestChapterInfo = ref<chapterInfoType | false>(false);

let title = ref('');
let tags = ref<tagItemType[]>([]);
let banner = ref<metaItemType[]>([]);
let character = ref<characterItem[]>([]);
let mangaCover = ref<string>('');
let isCollect = ref(false);
let editTagsDialog = ref(false);

// 轮播自动滚动时间间隔 默认为6秒钟
const interval = ref(6 * 1000);

const carouselType = computed(() => {
    const screen = config.screenType;

    if (['middle', 'large', '2k', '4k'].includes(screen)) {
        return 'card';
    } else {
        return '';
    }

})

const infoColum = computed(() => {
    const screen = config.screenType;

    switch (screen) {
        case 'large':
            return 3;
        case 'middle':
            return 2;
        case 'small':
            return 1;
        case 'mini':
            return 1;
        default:
            return 4;
    }
})

onMounted(async () => {
    // 渲染元数据
    await render_meta();
    await get_first_chapter();
    await get_latest_reading();

    get_collect_status();
})

/**
 * @description: 获取漫画首个章节
 * @return {*}
 */
async function get_first_chapter() {
    const mangaId = mangaInfo.mangaId;
    if (!mangaId) return;

    const infoRes = await chapterApi.get_first(mangaId, userConfig.order);
    firstChapterInfo.value = infoRes.request;
}

/**
 * @description: 获取最后一次的阅读记录
 * @return {*}
 */
async function get_latest_reading() {
    const mangaId = mangaInfo.mangaId;
    if (!mangaId) return;

    latestChapterInfo.value = await lastReadApi.get_latest(mangaId);
}

/**
 * @description: 开始阅读漫画第一章
 * @return {*}
 */
async function go_chapter() {
    const chapterInfo = latestChapterInfo.value ? latestChapterInfo.value : firstChapterInfo.value;

    const res = await chapterApi.get(chapterInfo.mangaId);
    global_set_json('chapterList', res.list);

    // 缓存章节信息
    global_set('chapterId', chapterInfo.chapterId);
    global_set('chapterName', chapterInfo.chapterName);
    global_set('chapterPath', chapterInfo.chapterPath);
    global_set('chapterType', chapterInfo.chapterType);
    global_set('chapterCover', chapterInfo.chapterCover);

    let page = chapterInfo.page || 1;

    router.push({
        name: chapterInfo.browseType,
        query: {
            chapterId: chapterInfo.chapterId
        },
        params: { page },
    });
}

/**
 * @description: 去往漫画章节列表页面
 * @return {*}
 */
function go_chapter_list() {
    router.push({
        name: 'chapter-list',
        query: {
            mangaId: mangaInfo.mangaId,
        },
        params: {
            browseType: mangaInfo.browseType,
            clear: '1'
        },
    });
}

/**
 * @description: 渲染元数据信息
 * @return {*}
 */
async function render_meta() {
    const route = useRoute();
    const mangaId = Number(route.query.mangaId);
    const res = await mangaApi.get_manga_info(mangaId);
    let bannerSoft: metaItemType[] = [];
    
    mangaInfo = res.info;
    tags.value = res.tags;
    title.value = res.info.mangaName;

    // 角色信息
    character.value = res.character;

    character.value.forEach(async (item: characterItem) => {
        const blob = await imageApi.get(item.characterPicture);
        item.blob = blob;
    })

    if (res.meta.length > 0) {
        // banner图
        for (let i = 0; i < res.meta.length; i++) {
            const metaItem = res.meta[i];
            if (metaItem.metaType === 'banner') {
                metaItem.blob = await imageApi.get(metaItem.metaFile);
                bannerSoft.push(metaItem);
            }
        }
    }

    // 漫画封面
    mangaCover.value = await imageApi.get(res.info.mangaCover);

    // 将图片进行排序
    bannerSoft.sort((a: any, b: any) => { return a.metaFile - b.metaFile });

    // 将处理好的结果赋值给ref对象 (将计算过程整合 避免多次渲染)
    banner.value = bannerSoft;
}

/**
 * @description: 角色列表的横向滚动事件
 * @param {*} event
 * @return {*}
 */
function character_wheel(event: Event) {
    const content = document.querySelector('.character-scroll');
    if (!content) return;
    event.preventDefault();

    content.scrollLeft += event.deltaY
}

async function get_collect_status() {
    if (!mangaInfo.mangaId) return;
    isCollect.value = (await collectApi.is_collect('manga', mangaInfo.mangaId)).request;
}

async function collect_manga() {
    if (!mangaInfo.mangaId) return;
    await collectApi.add_collect(Object.assign(mangaInfo, {
        collectType: 'manga',
    }));

    get_collect_status();
}

async function remove_collect() {
    if (!mangaInfo.mangaId) return;
    await collectApi.remove_collect('manga', mangaInfo.mangaId);
    get_collect_status();
}

function open_tag_box() {
    editTagsDialog.value = true;
    // update_tags_state();
}

/**
 * @description: 更新详情页的tag列表
 * @param {*} tagsParams
 * @return {*}
 */
function update_tags(tagsParams: tagItemType[]) {
    tags.value = tagsParams;
}

const __returned__ = { router, get mangaInfo() { return mangaInfo }, set mangaInfo(v) { mangaInfo = v }, get firstChapterInfo() { return firstChapterInfo }, set firstChapterInfo(v) { firstChapterInfo = v }, get latestChapterInfo() { return latestChapterInfo }, set latestChapterInfo(v) { latestChapterInfo = v }, get title() { return title }, set title(v) { title = v }, get tags() { return tags }, set tags(v) { tags = v }, get banner() { return banner }, set banner(v) { banner = v }, get character() { return character }, set character(v) { character = v }, get mangaCover() { return mangaCover }, set mangaCover(v) { mangaCover = v }, get isCollect() { return isCollect }, set isCollect(v) { isCollect = v }, get editTagsDialog() { return editTagsDialog }, set editTagsDialog(v) { editTagsDialog = v }, interval, carouselType, infoColum, get_first_chapter, get_latest_reading, go_chapter, go_chapter_list, render_meta, character_wheel, get_collect_status, collect_manga, remove_collect, open_tag_box, update_tags, mangaTagBox }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})